const categoryColors = {
  Food: 'from-green-400 to-emerald-500',
  Transport: 'from-blue-400 to-cyan-500',
  Entertainment: 'from-purple-400 to-indigo-500',
  Utilities: 'from-yellow-400 to-amber-500',
  Rent: 'from-red-400 to-rose-500',
  Shopping: 'from-pink-400 to-fuchsia-500',
  Healthcare: 'from-teal-400 to-emerald-500',
  Education: 'from-orange-400 to-deep-orange-500',
  Salary: 'from-lime-400 to-light-green-500',
  Other: 'from-gray-400 to-slate-500',
};

const defaultColors = [
  'from-green-400 to-emerald-500',
  'from-blue-400 to-cyan-500',
  'from-purple-400 to-indigo-500',
  'from-yellow-400 to-amber-500',
  'from-red-400 to-rose-500',
  'from-pink-400 to-fuchsia-500',
  'from-teal-400 to-emerald-500',
  'from-orange-400 to-deep-orange-500',
  'from-lime-400 to-light-green-500',
  'from-gray-400 to-slate-500',
];

export const getCategoryGradient = (category) => {
  return 'from-blue-500 to-indigo-600'; // A single, consistent gradient for all categories
};
